import { Skeleton } from '@/components/ui/skeleton';
import { DayLabor, formatHours } from '../my-hours.utils';
import { LaborEntryRow } from './LaborEntryRow';

interface DayCardProps {
  day: DayLabor;
  isLoading?: boolean;
  /** Panel path; entry links drill down below it. */
  linkBase: string;
}

export function DayCard({ day, isLoading = false, linkBase }: DayCardProps) {
  const hasEntries = day.entries.length > 0;

  return (
    <div className="bg-card rounded-lg border">
      {/* Day header */}
      <div className="flex items-center justify-between border-b px-4 py-3">
        <div>
          <span className="text-sm font-semibold">{day.dayName}</span>
          <span className="text-muted-foreground ml-2 text-xs">
            {day.dateFormatted}
          </span>
        </div>
        <div className="text-sm font-semibold">
          {isLoading ? (
            <Skeleton className="h-4 w-10" />
          ) : hasEntries ? (
            formatHours(day.totalHours)
          ) : (
            ''
          )}
        </div>
      </div>

      {/* Labor entries */}
      <div className="p-3">
        {isLoading ? (
          <div className="flex flex-col gap-2">
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
          </div>
        ) : hasEntries ? (
          <div className="flex flex-col gap-2">
            {day.entries.map((entry) => (
              <LaborEntryRow
                key={entry.recnum}
                entry={entry}
                linkBase={linkBase}
              />
            ))}
          </div>
        ) : (
          <div className="text-muted-foreground py-4 text-center text-sm">
            No work logged
          </div>
        )}
      </div>
    </div>
  );
}
